
const brands = {
  path: 'abrands',
  title: { i18n: 'brands' },
  name: 'abrands',
  component: () => import('@/views/agent/components/brands/index.vue')
};

export default brands;
